<template>
	<!-- 巡视信息列表 -->
	<div class="mod-config">
		<div>
			<el-card style="margin-top: -5px;" body-style="height: 100%; padding: 1;">
				<div class="title"> 文件审查记录 </div>
				<div class="line"></div>
				<el-container style="height: 100%;">
					<el-aside width="200px" style="border-right: 1px solid #eee">
						<div class="tree-container treeText" v-if="fileKindList != null">
							<el-tree :data="fileKindList" node-key="recId" default-expand-all
								:expand-on-click-node="false" highlight-current :props="defaultProps"
								@node-click="clickNode" style="background-color: white;">
								<span class="custom-tree-node treeText" slot-scope="{ node, data }">
									<el-tooltip class="item" effect="dark" :content="node.label" placement="top-start">
										<span>{{ node.label }}</span>
									</el-tooltip>
								</span>
							</el-tree>
						</div>
					</el-aside>
					<el-main style="padding: 0 10px;border-left: 1px solid #eee">
						<el-row>
							<el-col :span="pageSpan">
								<el-button class="btn" type="primary" size="small" v-if="showAdd"
									:disabled="fileType == ''" @click="addOrUpdateHandle()">添加</el-button>
								<el-button v-preventReClick class="btn" type="primary" size="small"
									:disabled="disabledBatchDelete" v-if="showDelete"
									@click="deleteBatchHandle()">删除</el-button>
								<el-button v-preventReClick class="btn" type="primary" size="small"
									@click="fileTypeSetingHandle()">目录设置</el-button>
							</el-col>
							<el-col :span="pageSpan">
								<div style="float: right;margin-right: 15px;vertical-align:middle;">
									<span
										style="font-size: 16px; font-weight:bold;vertical-align: middle;color: rgb(240, 159, 8)">
										已审查 {{ dataTotal.reviewedCount }}</span>
									<span
										style="font-size: 16px; font-weight:bold;vertical-align: middle; color: rgb(44, 106, 240);">
										未审查 {{ dataTotal.unexaminedCount }}</span>
									<span style="font-size: 16px; font-weight:bold;vertical-align: middle;">
										已接受 {{ dataTotal.acceptedCount }}</span>
									<span
										style="font-size: 16px; font-weight:bold;vertical-align: middle; color:rgb(250, 74, 74) ">
										未接受 {{ dataTotal.notAcceptedCount }}</span>
								</div>
							</el-col>
						</el-row>
						<div class="line1"></div>
						<el-row
							style="background-color: rgb(243, 247, 247);margin-top: -10px;margin-left: -20px;height: 45px;width: 101%;">
							<el-col :span="19" style="margin-left:20px">
								<el-form ref="form" :model="form" inline label-width="70px" label-position="left">
									<el-form-item label="文件名称" class="selFormItem">
										<el-input class="selSearchInput" placeholder="文件名称"
											v-model="fileName"></el-input>
									</el-form-item>
								</el-form>
							</el-col>
							<el-col :span="4" class="selBtnGroup" style="margin-top:8px">
								<el-button v-preventReClick class="btn" type="primary" size="small"
									@click="selGetDataList()" v-if="showSearch">查询</el-button>
								<el-button v-preventReClick class="rebtn" size="small"
									@click="resetFormData()">重置</el-button>
							</el-col>
						</el-row>
						<el-card style="margin-top: 0px;margin-left:-15px; overflow: unset" body-style="padding: 0;">
							<el-row style="margin-bottom: 10px;">
								<el-col :span="24">
									<div class="box" style="margin-top:-23px">
										<el-table :height="screenHeight - 277 + 'px'"
											:row-class-name="tableRowClassName" :row-style="selectRowBackground"
											ref="dataListTable" class="dataListTable" :data="dataList"
											header-align="center" style="width: 100%; margin-bottom: 20px;"
											header-cell-class-name="dataListTHeader" border
											@selection-change="handleSelectionChange" :cell-style="{ padding: '0px' }">
											<el-table-column header-align="center" align="center" width="50"
												type="selection" label=" "></el-table-column>
											<el-table-column type="index" label="NO." width="60" align="center">
												<template slot-scope="scope">{{ (pageIndex2 - 1) * pageSize +
													scope.$index +
													1 }}</template>
											</el-table-column>
											<el-table-column prop="fileName" label="文件名称" header-align="center"
												align="left" min-width="200" show-overflow-tooltip>
											</el-table-column>
											<el-table-column prop="fileNumber" label="份数" width="80" align="center">
											</el-table-column>
											<el-table-column prop="examineCompany" label="送审单位" width="160"
												align="center" show-overflow-tooltip>
											</el-table-column>
											<el-table-column prop="receiveTime" label="接收时间" width="100" align="center">
											</el-table-column>
											<el-table-column prop="receiveMan" label="接收人" width="120" align="center">
											</el-table-column>
											<el-table-column prop="examineTime" label="审查结束时间" width="120" align="center">
											</el-table-column>
											<el-table-column prop="examineStatus" label="审查状态" width="120"
												align="center">
												<template slot-scope="scope">
													<span v-if="scope.row.examineStatus == 0">未审查</span>
													<span v-if="scope.row.examineStatus == 1">已审查</span>
												</template>
											</el-table-column>
											<el-table-column prop="acceptTime" label="接受时间" width="100" align="center">
											</el-table-column>
											<el-table-column prop="acceptFlg" label="接收状态" width="150" align="center">
												<template slot-scope="scope">
													<span v-if="scope.row.acceptFlg == ''"></span>
													<span v-else-if="scope.row.acceptFlg == 0">未接受</span>
													<span v-else-if="scope.row.acceptFlg == 1">已接受</span>
												</template>
											</el-table-column>
											<!-- <el-table-column prop="examineSuggestion" label="审查意见" width="120" align="center"
								show-overflow-tooltip>
							</el-table-column>
							<el-table-column prop="returnStatus" label="返回状态" width="100" align="center">
								<template slot-scope="scope">
									<span v-if="scope.row.returnStatus == 0">未返回</span>
									<span v-if="scope.row.returnStatus == 1">已返回</span>
								</template>
							</el-table-column>-->
											<el-table-column label="操作" width="90" fixed="right"
												v-if="showDelete || showCheck || showEdit || showReturn || showFileDownload"
												align="left">
												<template slot-scope="scope">
													<!-- <el-button v-preventReClick type="primary" size="mini"
										@click="auditeHandle(scope.row.recNo)"
										v-if="showCheck && scope.row.examineStatus == '0'">审查确认</el-button> -->
													<!-- <el-button v-preventReClick type="text" size="mini"
										@click="viewHandle(scope.row.recNo)">查看</el-button> -->
													<el-button v-preventReClick type="text" size="mini"
														@click="addOrUpdateHandle(scope.row.recNo)"
														v-if="showEdit">修改</el-button>
													<!-- <el-button v-preventReClick type="text" size="mini"
										@click="replyHandle(scope.row.recNo)"
										v-if="showReturn && scope.row.returnStatus == '0'">确认返回</el-button>
									<el-button v-preventReClick type="text" size="mini"
										@click="deleteHandle(scope.row.recNo)"
										v-if="showDelete && scope.row.returnStatus == '0'">删除</el-button> -->
													<el-button v-preventReClick type="text" size="mini"
														@click="downloadHandle(scope.row.recNo)"
														v-if="showFileDownload">下载</el-button>
												</template>
											</el-table-column>
										</el-table>
									</div>
									<el-pagination class="my-pagination" @size-change="sizeChangeHandle"
										@current-change="currentChangeHandle" :current-page="pageIndex"
										:page-sizes="[10, 20, 50, 100]" :page-size="pageSize" :total="totalPage"
										layout="total, sizes, prev, pager, next, jumper">
									</el-pagination>
								</el-col>
							</el-row>
						</el-card>
					</el-main>
				</el-container>
			</el-card>
		</div>
		<add-or-update v-if="addOrUpdateVisible" ref="addOrUpdate" @refreshDataList="getDataList()"></add-or-update>
		<examination-view v-if="viewVisible" ref="examinationView"></examination-view>
		<file-type-seting v-if="fileTypeSetingVisible" ref="fileTypeSeting"
			@refreshDataList="getFileKindList()"></file-type-seting>
		<audit v-if="auditVisible" ref="audit" @refreshDataList="getDataList()"></audit>
		<reply v-if="replyVisible" ref="reply" @refreshDataList="getDataList()"></reply>
		<examination-download v-if="downloadVisible" ref="examinationDownload"
			@refreshDataList="getDataList()"></examination-download>
	</div>
</template>
<script>
import AddOrUpdate from './examination-add-or-update'
import ExaminationView from './examination-view'
import FileTypeSeting from './file-type-seting'
import audit from './examination-audit'
import reply from './examination-reply'
import $common from "@/utils/common.js"
import ExaminationDownload from "./examination-download.vue"
export default {
	data() {
		return {
			showSearch: false,
			showAdd: false,
			showFileKindSet: false,
			showFileDownload: false,
			showCheck: false,
			showEdit: false,
			showReturn: false,
			showArchive: false,
			showDelete: false,
			downloadVisible: false,
			pageSpan: 12,
			tabIndex: '',
			fileTypeSetingVisible: false,
			addOrUpdateVisible: false,
			viewVisible: false,
			auditVisible: false,
			replyVisible: false,
			fileKindVisible: false,
			disabledBatchDelete: true,
			recNo: '',
			form: {},
			returnStatus: '',
			examineStatus: '',
			examineCompany: '',
			fileName: '',
			fileType: '',
			examineTime: [],
			dataList: [],
			tableSelVal: [],
			tableSelIdArray: [],
			fileKindList: [],
			selAllFlg: false,
			closeTime: [],
			//审查文件类型
			documentTypeList: [],
			//当前页码
			pageIndex: 1,
			// 显示序号
			pageIndex2: 1,
			//当前记录数
			pageSize: 20,
			//总页数
			totalPage: 0,
			screenHeight: 0,
			options: [
				{
					value: "0",
					label: "未审查"
				},
				{
					value: "1",
					label: "审查"
				}
			],
			option: [
				{
					value: "0",
					label: "未返回"
				},
				{
					value: "1",
					label: "返回"
				}
			],
			defaultProps: {
				children: 'childList',
				label: 'kindName'
			},
			dataTotal: {
				reviewedCount: 0,
				unexaminedCount: 0,
				acceptedCount: 0,
				notAcceptedCount: 0
			},
		};
	},
	components: {
		AddOrUpdate,
		ExaminationView,
		audit,
		reply,
		FileTypeSeting,
		ExaminationDownload
	},
	mounted() {
		this.screenHeight = window.innerHeight
		this.showSearch = $common.isAuth('examination:search');
		this.showFileKindSet = $common.isAuth('examination:file:kind:set');
		this.showAdd = $common.isAuth('examination:add');
		this.showEdit = $common.isAuth('examination:edit');
		this.showDelete = $common.isAuth('examination:delete');
		this.showCheck = $common.isAuth('examination:check');
		this.showArchive = $common.isAuth('examination:archive');
		this.showReturn = $common.isAuth('examination:return');
		this.showFileDownload = $common.isAuth('examination:download');
		if (!this.showFileKindSet && !this.showAdd) {
			this.pageSpan = 24;
		}
		this.getFileKindList();
		this.getDataList();
	},
	methods: {
		selectFile(url) {
			window.open(url);
		},
		getFileKindList() {
			this.$http({
				url: this.$store.state.httpUrl + "/business/filekindconfig/getTreeList",
				method: "get",
				params: {
					workNo: $common.getItem("workNo"),
					kindType: "01",
					limit: this.pageSize,
					page: this.pageIndex
				},
			}).then(({ data }) => {
				if (data && data.resultCode === 200) {
					this.fileKindList = data.body;
					this.totalPage = data.body.totalCount;
				}
			});
		},
		countFileExamine() {
			this.$http({
				url: this.$store.state.httpUrl + "/business/fileexamineinfo/countFileExamine",
				method: 'get',
				params: this.$http.adornParams({
					workNo: $common.getItem("workNo"),
					subjectNo: $common.getItem("subjectNo"),
					fileType: this.fileType,
					beginTime: this.examineTime[0] ? this.examineTime[0] : "",
					endTime: this.examineTime[1] ? this.examineTime[1] : "",
					examineCompany: this.examineCompany,
					examineStatus: this.examineStatus,
					returnStatus: this.returnStatus,
					fileName: this.fileName
				})
			}).then(({ data }) => {
				if (data && data.resultCode === 200) {
					this.dataTotal = data.body
				}
			})
		},
		//获取数据
		getDataList() {
			this.countFileExamine()
			if (this.showSearch) {
				this.$http({
					url: this.$store.state.httpUrl + "/business/fileexamineinfo/list",
					method: "get",
					params: {
						workNo: $common.getItem("workNo"),
						subjectNo: $common.getItem("subjectNo"),
						fileType: this.fileType,
						beginTime: this.examineTime[0] ? this.examineTime[0] : "",
						endTime: this.examineTime[1] ? this.examineTime[1] : "",
						examineCompany: this.examineCompany,
						examineStatus: this.examineStatus,
						returnStatus: this.returnStatus,
						limit: this.pageSize,
						page: this.pageIndex,
						fileName: this.fileName
					},
				}).then(({ data }) => {
					if (data && data.resultCode === 200) {
						this.dataList = data.body.records;
						this.totalPage = data.body.totalCount;
						this.pageIndex2 = this.pageIndex
					}
				});
			}
		},
		clickNode(data) {
			this.fileType = data.recId
			this.pageIndex = 1
			this.getDataList()
		},
		archiveFile(id) {
			this.$confirm(`确定对选中的数据进行归档操作?`, '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			}).then(() => {
				this.$http({
					url: this.$store.state.httpUrl + "/business/fileexamineinfo/archiveFile/" + id,
					method: "get",
					data: this.$http.adornData({
						recNo: id
					})
				}).then(({ data }) => {
					if (data && data.resultCode === 200) {
						this.$message({
							message: '操作成功',
							type: 'success',
							duration: 1500,
							onClose: () => {
								this.getDataList()
							}
						})
					} else {
						this.$message.error(data.msg)
					}
				});
			});
		},
		removeArchiveFile(id) {
			this.$confirm(`确定对选中的数据进行取消归档操作?`, '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			}).then(() => {
				this.$http({
					url: this.$store.state.httpUrl + "/business/fileexamineinfo/removeArchiveFile/" + id,
					method: "get",
					data: this.$http.adornData({
						recNo: id
					})
				}).then(({ data }) => {
					if (data && data.resultCode === 200) {
						this.$message({
							message: '操作成功',
							type: 'success',
							duration: 1500,
							onClose: () => {
								this.getDataList()
							}
						})
					} else {
						this.$message.error(data.msg)
					}
				});
			});
		},
		fileTypeSetingHandle() {
			this.fileTypeSetingVisible = true
			this.$nextTick(() => {
				this.$refs.fileTypeSeting.init()
			})
		},
		// 确认返回
		replyHandle(id) {
			this.replyVisible = true
			this.$nextTick(() => {
				this.$refs.reply.init(id)
			})
		},
		downloadHandle(recNo) {
			this.downloadVisible = true;
			this.$nextTick(() => {
				this.$refs.examinationDownload.init(recNo)
			})
		},
		//删除
		deleteHandle(id) {
			this.recNo = id ? id : 0;
			this.$confirm(`确定对选中的数据进行删除操作?`, '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			}).then(() => {
				this.$http({
					url: this.$store.state.httpUrl + `/business/fileexamineinfo/delete/${this.recNo}`,
					method: "POST",
					data: this.$http.adornData({
						recNo: id
					})
				}).then(({ data }) => {
					if (data && data.resultCode === 200) {
						this.$message({
							message: '操作成功',
							type: 'success',
							duration: 1500,
							onClose: () => {
								this.getDataList()
							}
						})
					}
				});
			})
				.catch(() => { })
		},
		deleteBatchHandle() {
			this.$confirm(`确定对选中的数据进行删除操作？`, '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			}).then(() => {
				let records = this.tableSelVal.map((item) => item.recNo);
				this.$http({
					url: this.$store.state.httpUrl + `/business/fileexamineinfo/deleteBatch`,
					method: 'post',
					data: this.$http.adornData({
						records: records
					})
				}).then(({ data }) => {
					if (data && data.resultCode === 200) {
						this.$message({
							message: '操作成功',
							type: 'success',
							duration: 1500,
							onClose: () => {
								this.getDataList()
							}
						})
					}
				});
			})
				.catch(() => { })
		},
		fileKindHandle() {
			this.fileKindVisible = true;
			this.$nextTick(() => {
				this.$refs.examinationSetting.init()
			})
		},
		siteContentViewHeight() {
			var height = this.$store.state.common.documentClientHeight - 170;
			return { height: height + 'px' }
		},
		handleSelectionChange(val) {
			this.tableSelVal = val;
			if (val.length > 0) {
				this.disabledBatchDelete = false;
			} else {
				this.disabledBatchDelete = true;
			}
		},
		// 每页数
		sizeChangeHandle(val) {
			this.pageSize = val
			this.pageIndex = 1
			this.getDataList()
		},
		// 当前页
		currentChangeHandle(val) {
			this.pageIndex = val
			this.getDataList()
		},
		tableRowClassName({ row, rowIndex }) {
			let color = ''
			for (let item of this.tableSelVal) {
				if (item.id === row.id) color = 'table-SelectedRow-bgcolor'
			}
			return color
		},
		addOrUpdateHandle(id) {
			this.addOrUpdateVisible = true
			this.$nextTick(() => {
				this.$refs.addOrUpdate.init(id, this.fileType)
			})
		},
		viewHandle(id) {
			this.viewVisible = true
			this.$nextTick(() => {
				this.$refs.examinationView.init(id, this.fileType)
			})
		},
		setCategory(value) {
			this.fileType = value;
			this.pageIndex = 1;
			this.getDataList();
		},
		selGetDataList() {
			this.pageIndex = 1;
			this.getDataList();
		},
		toggleAllSelection() {
			this.$refs.dataListTable.toggleAllSelection();
		},
		resetFormData() {
			this.examineCompany = "";
			this.returnStatus = "";
			this.examineStatus = "";
			this.examineTime = [];
			this.fileType = '';
			this.fileName = '';
			this.getDataList();
		},
		tableRowClassName({ row, rowIndex }) {
			return $common.tableRowClassName({ row, rowIndex });
		},
		selectRowBackground({ row }) {
			const checkIdList = this.tableSelVal.map((item) => item.recNo);
			if (checkIdList.includes(row.recNo)) {
				return {
					backgroundColor: "#fae8cb",
				};
			}
		},
	}
};
</script>
<style lang="scss" scoped="scoped">
.selItemText {
	font-size: 14px;
	color: #1c1c1c;
	display: inline-block;
	width: 80px;
}

.tree-container {
	background-color: white;
}

.treeText {
	white-space: nowrap;
	/*设置不换行*/
	overflow: hidden;
	/*设置隐藏*/
	text-overflow: ellipsis;
	/*设置隐藏部分为省略号*/
}

.dataListTable {
	margin-top: 5px;
}

.my-pagination {
	margin-right: 20px !important;
}

// 设置表头样式
::v-deep(.el-table th.el-table__cell) {
	// background-color: #d3e2f4 !important;
	font-size: 15px;
	padding: 2px 0;
}

.line1 {
	margin-top: 8px;
	margin-left: -10px;
	margin-bottom: 10px;
	width: 100%;
	height: 2px;
	background: rgb(190, 187, 187);
}

::v-deep(.selSearchInput .el-input__inner) {
	width: 150px !important;
	height: 30px !important;
}

::v-deep(.selFormItem .el-form-item__label) {
	font-size: smaller;
}
</style>
